<template>
  <article class="access-dc-card">
    <div class="access-dc-card__row">
      <span class="type-label">{{ $t('accessDc.historicalAccessDc.col.surname') }}</span>
      <span class="type-value">{{ item.surname }}</span>
    </div>
    <div class="access-dc-card__row">
      <span class="type-label">{{ $t('accessDc.historicalAccessDc.col.name') }}</span>
      <span class="type-value">{{ item.name }}</span>
    </div>
    <div class="access-dc-card__row">
      <span class="type-label">{{ $t('accessDc.historicalAccessDc.col.date') }}</span>
      <span class="type-value">{{ formatDate(item.from) }}</span>
    </div>
    <div class="access-dc-card__row">
      <span class="type-label">{{ $t('accessDc.historicalAccessDc.col.from') }}</span>
      <span class="type-value">{{ formatTime(item.from) }}</span>
    </div>
    <div class="access-dc-card__row">
      <span class="type-label">{{ $t('accessDc.historicalAccessDc.col.to') }}</span>
      <span class="type-value">{{ formatTime(item.to) }}</span>
    </div>
  </article>
</template>

<script setup>
defineProps({ item: { type: Object, required: true } })

function parseDate(str) {
  if (!str) return null
  const d = new Date(str.replace(' ', 'T'))
  return isNaN(d.getTime()) ? null : d
}

function formatDate(str) {
  const d = parseDate(str)
  if (!d) return '--/--/----'
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

function formatTime(str) {
  const d = parseDate(str)
  if (!d) return '--:--:--'
  return d.toTimeString().slice(0, 8)
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.access-dc-card {
  padding: 12px 16px;
  border-bottom: 1px solid $grayTwo;
}

.access-dc-card__row {
  display: flex;
  gap: $cardInnerGap;
  align-items: baseline;
  padding: 4px 0;
}
</style>
